import React from 'react';
import MessageFilterDropdown from "./MessageFilterDropdown";
import { Stack } from "@mui/system";
import { EntityPaginationFields } from "../../../../types";
import { Alert, Box, CircularProgress, Pagination } from "@mui/material";
import { MessageCardListMobile } from "..";
import Chip from "../../../../@core/components/mui/chip";
import { MessagesComponentProps } from '../../Messages';
import {userStorage} from "../../../../utils/localStorage";
import {NuevoMensaje} from "../NuevoMensaje";

function MessagesMobile({ query, handleSearch, form }: MessagesComponentProps) {

    return (
        <Stack spacing={2}>
            {
                userStorage.canCreateNewMessage() &&
                <Box width={1/4}>
                    <NuevoMensaje />
                </Box>
            }
            <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
                <Chip
                    size='small'
                    label={
                        query.status === 'loading' ?
                            'Buscando...' :
                            query.status === 'success' ?
                                `${query.paginacion[EntityPaginationFields.CantRecords]} resultados` : ''}
                    color={query.status === 'loading' ? 'secondary' : 'primary'}
                />
                <MessageFilterDropdown form={form} />
            </Stack>
            {
                query.status === 'loading' &&
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                    <CircularProgress disableShrink sx={{ mt: 6 }} />
                </Box>
            }
            {
                query.status === 'error' &&
                <Alert severity='error'>Se produjo un error al cargar los mensajes.</Alert>
            }
            {
                query.status === 'success' &&
                (!query.entities.length ?
                    <Alert severity='info'>
                        No se encontraron mensajes para esta selección.
                    </Alert> :
                    <MessageCardListMobile messages={query.entities} />)
            }
            {
                (query.status === 'success' && !!query.entities.length) &&
                <Stack alignItems='center'>
                    <Pagination
                        count={query.paginacion[EntityPaginationFields.CantPages]}
                        page={query.paginacion[EntityPaginationFields.ActualPage]}
                        onChange={(_, page) => query.onChange(page)}
                    />
                </Stack>
            }
        </Stack>
    );
}

export default MessagesMobile;
